<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="出质人" >
            <template slot-scope="scope">
              {{ scope.row.pledgor_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="质权人">
            <template slot-scope="scope">
              {{ scope.row.pledgee_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="质押金额">
            <template slot-scope="scope">
              {{ scope.row.pledge_amount || '-' }}
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'equityPledgeList',
    data() {
        return {
            title: '股权质押',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>